<script lang="ts">
    import { language } from "src/lang";
    import SettingPage from "src/lib/UI/GUI/SettingPage.svelte";
</script>

<SettingPage title={language.files}>
</SettingPage>
